import api from "../api";
import { IPaginateResponse } from "@/interfaces/Fetch";
import {
  TeamUser,
  TeamUserFilters,
  TeamUserFormSend,
} from "@/interfaces/TeamUser";

export const teamUsersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTeamUsers: build.query<
      IPaginateResponse<TeamUser>,
      [string, TeamUserFilters]
    >({
      query: ([teamId, params]) => ({
        url: `/teams/${teamId}/users`,
        params,
      }),
      providesTags: (_, __, [teamId]) => [
        { type: "TeamUsers", teamId, id: "LIST" },
      ],
    }),
    storeTeamUser: build.mutation<void, [string, TeamUserFormSend]>({
      query: ([teamId, body]) => ({
        url: `/teams/${teamId}/users`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_, _error, [teamId]) => [
        { type: "CommercialBooking", id: "LIST" },
        { type: "TeamUsers", teamId, id: "LIST" },
      ],
    }),
    destroyTeamUser: build.mutation<void, [string, string]>({
      query: ([teamId, userId]) => ({
        url: `/teams/${teamId}/users/${userId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_, _error, [teamId]) => [
        { type: "CommercialBooking", id: "LIST" },
        { type: "TeamUsers", teamId, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetTeamUsersQuery,
  useLazyGetTeamUsersQuery,
  useStoreTeamUserMutation,
  useDestroyTeamUserMutation,
} = teamUsersApi;
